var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.207 3.597a1.884 1.884 0 00-3.163 1.34c-.008.485.172.955.505 1.31L9.317 12l-5.768 5.752a1.876 1.876 0 001.34 3.204c.5 0 .978-.2 1.33-.553l5.769-5.752 5.755 5.752a1.88 1.88 0 002.08.46A1.88 1.88 0 0021 19.091a1.87 1.87 0 00-.599-1.339L14.633 12l5.768-5.752a1.876 1.876 0 00.462-2.075A1.875 1.875 0 0019.086 3a1.885 1.885 0 00-1.343.597l-5.768 5.752-5.768-5.752z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.90dbffb79d1d9dcd26112eeb0d8a5ade.svg";